module.exports = __webpack_public_path__ + "img/logo2.2e55ac80.png";